import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Crown, Plane, Gift, TrendingUp, Zap, Star } from 'lucide-react';

const FEATURE_INFO = {
  trips: {
    title: 'Trips & Budgets',
    description: 'Track spending for trips, projects, and goals with dedicated budgets.',
    icon: Plane,
    tier: 'Prime'
  },
  deals: {
    title: 'Personalized Deals',
    description: 'Get cashback offers and discounts tailored to your spending habits.',
    icon: Gift,
    tier: 'Prime'
  },
  smartAnalysis: {
    title: 'Smart Analysis',
    description: 'AI-powered insights that analyze your spending patterns.',
    icon: TrendingUp,
    tier: 'Prime'
  },
  predictiveBudgeting: {
    title: 'Predictive Budgeting',
    description: 'AI forecasts your future spending and suggests optimal budgets.',
    icon: Zap,
    tier: 'Elite'
  },
  scans: {
    title: 'More Receipt Scans',
    description: 'You\'ve used all your scans this month. Upgrade for more!',
    icon: Star,
    tier: 'Prime'
  }
};

export function UpgradeModal({ open, onOpenChange, feature, onUpgrade }) {
  const info = FEATURE_INFO[feature] || FEATURE_INFO.trips;
  const Icon = info.icon;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm mx-auto">
        <DialogHeader className="text-center">
          <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-violet-500 to-fuchsia-500 flex items-center justify-center mx-auto mb-4 shadow-lg">
            <Icon className="w-8 h-8 text-white" />
          </div>
          <DialogTitle className="text-xl">{info.title}</DialogTitle>
          <DialogDescription className="text-center mt-2">
            {info.description}
          </DialogDescription>
        </DialogHeader>
        
        <div className="mt-4 p-4 rounded-xl bg-gradient-to-r from-violet-500/10 to-fuchsia-500/10 border border-violet-500/20">
          <div className="flex items-center gap-3">
            <Crown className="w-5 h-5 text-violet-500" />
            <div>
              <p className="font-semibold text-sm">Unlock with {info.tier}</p>
              <p className="text-xs text-muted-foreground">
                {info.tier === 'Prime' ? 'Starting at $4.99/month' : 'Starting at $9.99/month'}
              </p>
            </div>
          </div>
        </div>

        <div className="flex gap-3 mt-4">
          <Button variant="outline" className="flex-1" onClick={() => onOpenChange(false)}>
            Maybe Later
          </Button>
          <Button 
            className="flex-1 bg-gradient-to-r from-violet-500 to-fuchsia-500 hover:from-violet-600 hover:to-fuchsia-600"
            onClick={onUpgrade}
          >
            View Plans
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
